import { createRouter, createWebHashHistory } from 'vue-router'
import NewRegistrationForm from '@/views/NewRegistrationForm.vue'
import SuccessGifty from '@/views/SuccessGifty.vue'
import { useRegistrationStore } from '@/stores/registrationStore' 

const routes = [
  {
    path: '/registeration/form',
    name: 'newForm',
    component: NewRegistrationForm,
  },
  {
    path: '/registeration/success',
    name: 'successRegistration',
    component: SuccessGifty,
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
})

router.beforeEach((to, from, next) => {
  const store = useRegistrationStore()

  const step = Number(store.step) || 1

  if (step === 1) {
    if (to.name !== 'newForm') return next({ name: 'newForm' })
    return next()
  }

  if (step === 2) {
    if (to.name !== 'successRegistration') {
      return next({ name: 'successRegistration' })
    }
    return next()
  }

  return next({ name: 'newForm' })
})

export default router
